import React, { useEffect, useRef, useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Buffer } from 'buffer';

import { IMaterialPrice } from '../../types/material';

import { useUserContext } from '../../contexts/userContext';

import { MaterialPriceService } from '../../services/materialPriceService';

import VendorMaterialPricingTable from '../tables/vendorMaterialPricingTable';
import Json from '../json';

import '../../styles/vendorMaterialsForm.scss';


export interface IVendorMaterialsFormProps {
	id: string;
	data: IMaterialPrice[];
}

const VendorMaterialsForm: React.FunctionComponent<IVendorMaterialsFormProps> = ({ id, data }) => {
	const { instance } = useMsal();
	const userContext = useUserContext();
	const navigate = useNavigate();
	const [downloadUrl, setDownloadUrl] = useState("#");
	const [fileName, setFileName] = useState("");
	const ref = useRef<HTMLAnchorElement | null>(null);

	const [gridView, setGridView] = useState<IMaterialPrice[]>();

	//Filtering
	const [materialOptions, setMaterialOptions] = useState<string[]>([]);
	const [customerOptions, setCustomerOptions] = useState<string[]>([]);
	const [materialFilter, setMaterialFilter] = useState("All");
	const [customerFilter, setCustomerFilter] = useState("All");
	const [dateFilter, setDateFilter] = useState<Date>(new Date);

	useEffect(() => {
		loadFilterOptions();
	}, [])

	const loadFilterOptions = async () => {
		if (data) {
			let customers: string[] = [];
			let materials: string[] = [];

			data.map((item) => {
				if (item.customerName && !customers.includes(item.customerName)) {
					customers.push(item.customerName);
				}

				if (item.materialName && !materials.includes(item.materialName)) {
					materials.push(item.materialName);
				}
			});

			setGridView(data);
			setCustomerOptions(customers.sort());
			setMaterialOptions(materials.sort());
		}
	}



	const getMaterialPriceSheet = () => {
		MaterialPriceService.getMaterialPriceSheet(id)
			.then((response) => {
				console.log('MaterialService.getMaterialPriceSheet: SUCCESS', response);

				let tempLink = document.createElement('a');
				const blob = new Blob([Buffer.from(response.data)], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheet.sheet',
				});
				tempLink.href = URL.createObjectURL(new Blob([blob]));
				tempLink.setAttribute('download', 'MaterialPricing.xlsx');
				tempLink.click();
				tempLink.remove();
			})
			.catch((error) => {
				console.log('MaterialService.getMaterialPriceSheet: ERROR', error);
			})
			.finally(() => {

			});
	}

	return (
		<div className="hwi-vendor-materials-form">
			<section className="search-bar">
				<section className="search-options">
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<FormControl size="small" className="option">
							<InputLabel>Material</InputLabel>
							<Select
								value={materialFilter}
								defaultValue="All"
								label="Material"
								onChange={(event: SelectChangeEvent) => { setMaterialFilter(event.target.value) }}
							>
								<MenuItem value="All" key="-1">All</MenuItem>
								{materialOptions.map((item, index) => (
									<MenuItem value={item} key={index}>{item}</MenuItem>
								))}
							</Select>
						</FormControl>
						<FormControl size="small" className="option">
							<InputLabel>Customer</InputLabel>
							<Select
								value={customerFilter}
								label="Customer"
								onChange={(event: SelectChangeEvent) => { setCustomerFilter(event.target.value) }}
							>
								<MenuItem value="All" key="-1">All</MenuItem>
								{customerOptions.map((item, index) => (
									<MenuItem value={item} key={index}>{item}</MenuItem>
								))}
							</Select>
						</FormControl>
						{/* <FormControl size="small" className="option">
							<DatePicker label="Date" className="last-audit-date-field" value={dayjs(dateFilter)} onChange={(value) => { if (value) setDateFilter(value.toDate()) }} />
						</FormControl> */}
						<FormControl size="small" className="button">
							<Button fullWidth variant="contained" onClick={getMaterialPriceSheet}>Get Price Sheet</Button>
						</FormControl>
						<FormControl size="small" className="button">
							<Button variant="contained" onClick={() => { navigate("/vendor/" + id + "/pricing") }}>Upload Pricing</Button>
						</FormControl>
					</LocalizationProvider>
				</section>
			</section>
			<section className="results">
				<VendorMaterialPricingTable id={id} data={gridView} validate={false} customer={customerFilter} material={materialFilter} date={dateFilter} unloadData={() => { }} hideControls={true}></VendorMaterialPricingTable>
			</section>
			
		</div>
	)
}

export default VendorMaterialsForm;